export { InnerMarquee } from './InnerMarquee';
